var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"nadaba-loader"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cst-bank-spinner"},[_c('div',{staticClass:"cst-bank-spinner-bounce1"}),_c('div',{staticClass:"cst-bank-spinner-bounce2"}),_c('div',{staticClass:"cst-bank-spinner-bounce3"})])
}]

export { render, staticRenderFns }